import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Dropdown } from 'primereact/dropdown';

import "../../../css/layouts.css"
import AreaControls from "./Controls/AreaControls";
import DynamicContainer from './Controls/DynamicContainer';

import LayoutNameController from './Controls/LayoutNameController';
import { unitOptions } from '../../../../../config/layoutConstants';

const DrawingArea = ({
    areas,
    setAreas,
    currentAspectRatio,
    setCurrentAspectRatio,
    layoutName,
    setLayoutName,
    titleError,
    handleUnitChange,
    isSaveDisabled,
    setIsSaveDisabled
}) => {
    const { t } = useTranslation();
    const unit = useSelector((state) => state.layout.unit);
    const [overlappingAreas, setOverlappingAreas] = useState([]);
    const scrollableDivRef = useRef(null);

    return (
        <>
            {/* Preview Area */}
            <DynamicContainer
                areas={areas}
                setAreas={setAreas}
                currentAspectRatio={currentAspectRatio}
                setCurrentAspectRatio={setCurrentAspectRatio}
                scrollableDivRef={scrollableDivRef}

            />
            {/* Controls */}

            <div className="flex flex-col w-full lg:w-[40%]  mr-3">
                <div className="mt-1 flex  w-100 lg:w-1/2">
                    <div className="w-75">
                        <label className="text-sm font-medium mb-1">{t('layouts.designer_title_label')}</label>
                        <div className="d-flex mb-3 ">

                            <LayoutNameController layoutName={layoutName} setLayoutName={setLayoutName} titleError={titleError} />

                        </div>
                    </div>

                    <div className="w-25">
                        <label className="text-sm font-medium mb-1">{t('layouts.designer_unit')}</label>
                        <Dropdown
                            value={unit?.value || unitOptions[0]}
                            options={unitOptions}
                            optionLabel="label"
                            optionValue="value"
                            className="mb-3 mt-1 w-100"
                            onChange={handleUnitChange}
                            placeholder={t('layouts.designer_select_unit')}
                        />
                    </div>

                </div>
                <div className="flex flex-col w-100 lg:w-1/2">
                    <AreaControls
                        areas={areas}
                        setAreas={setAreas}
                        currentAspectRatio={currentAspectRatio}
                        isSaveDisabled={isSaveDisabled}
                        overlappingAreas={overlappingAreas}
                        setOverlappingAreas={setOverlappingAreas}
                        setIsSaveDisabled={setIsSaveDisabled}
                        scrollableDivRef={scrollableDivRef}

                    />
                    {overlappingAreas.length > 0 && (
                        <div className=" flex mt-3 text-white font-medium  alert bg-orange-300" role="alert">
                            <i className="ml-3 mr-3 mt-4 fa-solid fa-triangle-exclamation fa-lg"></i>
                            <div className="ml-3">
                                {t('layouts.designer_zones_overlapped')}{" "}
                                {overlappingAreas.join(", ")}.
                                <br />
                                {t('layouts.designer_adjust_zones')}
                            </div>
                        </div>
                    )}


                </div>
            </div>
        </>
    );
};

export default DrawingArea;
